import React from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    Stack,
    IconButton,
    Drawer,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

function DrawerAppBar({ onClickFeedbackButton }) {
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prev) => !prev);
    };

    const RightContent = (
        <Stack
            direction={{ xs: "column", md: "row" }}
            sx={{
                alignItems: { xs: "flex-start", md: "center" },
                gap: { xs: 1, md: 0 },
                p: { xs: 1, md: 0 }
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1} mb={{ xs: 1, md: 0 }}>
                <Typography
                    sx={{
                        fontSize: "2rem",
                    }}
                >
                    Support us:
                </Typography>
                <Stack
                    onClick={() => {
                        window.open("https://buymeacoffee.com/flyingharley", "");
                    }}
                >
                    <img
                        src="/buymecoffee.png"
                        alt="buymecoffee"
                        style={{
                            marginLeft: "3rem",
                            marginRight: "2rem",
                            width: "5rem",
                            height: "5rem",
                            cursor: "pointer",
                        }}
                    />
                </Stack>
                <Stack
                    onClick={() => {
                        window.open(
                            "https://paypal.me/flyingharley?country.x=VN&locale.x=en_US",
                            ""
                        );
                    }}
                >
                    <img
                        src="/paypal.png"
                        alt="paypal"
                        style={{
                            width: "5rem",
                            height: "5rem",
                            cursor: "pointer",
                        }}
                    />
                </Stack>
            </Stack>

            <Stack
                direction="row"
                sx={{
                    padding: "1.5rem",
                    border: "1px solid #000000",
                    borderRadius: "1rem",
                    cursor: "pointer",
                    alignItems: "center",
                    marginLeft: { xs: 0, md: "2rem" },
                    marginRight: { xs: 0, md: "2rem" },
                }}
                onClick={() => {
                    onClickFeedbackButton();
                    setMobileOpen(false);
                }}
            >
                <Typography
                    sx={{
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        fontWeight: "bold",
                    }}
                >
                    Feedback
                </Typography>
            </Stack>

            <Stack
                direction="row"
                sx={{
                    padding: "1rem",
                    border: "1px solid #5B64EC",
                    borderRadius: "1rem",
                    cursor: "pointer",
                    alignItems: "center",
                    marginLeft: { xs: 0, md: "2rem" },
                    marginRight: { xs: 0, md: "2rem" },
                }}
                onClick={() => {
                    window.open("https://discord.gg/yFsmXp4D","");
                }}
            >
                <Stack>
                    <img
                        src="/discord.png"
                        alt="discord"
                        style={{
                            width: "5rem",
                            height: "5rem",
                            cursor: "pointer",
                            borderRadius: "1rem",
                        }}
                    />
                </Stack>
                <Stack direction="column" alignItems="start" sx={{ marginLeft: "1rem" }}>
                    <Typography
                        sx={{
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            color: "#5B64EC",
                        }}
                    >
                        CONACT US ON
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "1.8rem",
                            fontWeight: "bold",
                            color: "#5B64EC",
                        }}
                    >
                        Discord
                    </Typography>
                </Stack>

            </Stack>


            <a
                href="https://www.producthunt.com/posts/ezclean-for-developers?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-ezclean&#0045;for&#0045;developers"
                target="_blank"
                rel="noreferrer"
                style={{
                paddingRight: "2rem"
                }}
            >
                <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=953860&theme=light&t=1745251626266"
                    alt="EzClean&#0032;&#0045;&#0032;For&#0032;Developers - Save&#0032;hundred&#0032;of&#0032;gigabytes | Product Hunt"
                    width="250"
                    height="54"
                />
            </a>
        </Stack>
    );

    return (
        <Box sx={{ display: "flex", width: "100%" }}>
            <AppBar
                position="static"
                color="transparent"
                elevation={0}
                sx={{
                    backdropFilter: "blur(8px)",
                }}
            >
                <Toolbar sx={{ width: "100%" }}>
                    <Stack
                        direction="row"
                        sx={{
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Stack
                            direction="row"
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <img
                                src="../logo.png"
                                alt="logo"
                                style={{
                                    width: "5rem",
                                    height: "5rem",
                                }}
                            />
                            <Typography
                                sx={{
                                    marginLeft: "2rem",
                                    fontSize: "2.25rem",
                                    fontWeight: "700",
                                }}
                            >
                                EzClean - For Developers
                            </Typography>
                        </Stack>

                        <Box
                            sx={{
                                display: { xs: "none", md: "flex" },
                                alignItems: "center",
                                marginRight: "2rem"
                            }}
                        >
                            {RightContent}
                        </Box>

                        <IconButton
                            color="inherit"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{ display: { xs: "flex", md: "none" }, marginRight: "2rem" }}
                        >
                            <MenuIcon sx={{ fontSize: "6rem", color: "black", marginRight: "2rem" }} />
                        </IconButton>
                    </Stack>
                </Toolbar>
            </AppBar>

            <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                sx={{
                    display: { xs: "block", md: "none" },
                    "& .MuiDrawer-paper": {
                        width: "80vw",
                        maxWidth: 360,
                        paddingTop: "1rem",
                    },
                }}
            >
                {RightContent}
            </Drawer>
        </Box>
    );
}

export default DrawerAppBar;